
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./EnvelopeViewer": () => {
return Promise.all(/*  | __federation_expose_EnvelopeViewer */ [__webpack_require__.e(839), __webpack_require__.e(36), __webpack_require__.e(318), __webpack_require__.e(153), __webpack_require__.e(456), __webpack_require__.e(127)]).then(() => (() => (__webpack_require__(11043))));
},
"./envelopeViewerModule": () => {
return Promise.all(/*  | __federation_expose_envelopeViewerModule */ [__webpack_require__.e(839), __webpack_require__.e(36), __webpack_require__.e(318), __webpack_require__.e(153), __webpack_require__.e(456), __webpack_require__.e(127), __webpack_require__.e(627)]).then(() => (() => (__webpack_require__(50868))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };